import {
  Tooltip,
  Card,
  CardHeader,
  IconButton,
  Box,
  MenuItem,
  Divider,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  TextField,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  InputLabel,
  Select,
  DialogActions,
  CardContent,
  Button,
  Alert,
} from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  downloadSpecialOutputReportingTemplate,
  getSubmissions,
  getSubordinatePendingReports,
  removeSubmission,
  submitAssignmentReport,
} from "../../../store/rbm/actions";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import CustomProgressLine from "./CustomProgressLine";

import PersonIcon from "@mui/icons-material/Person";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

import loadingGif from "../../assets/loading.gif";
import PercentageSelect from "../../common/components/PercentageSelect";
import {
  computeMonthlyStatuses,
  getMeasurementBounds,
  monthsOfQuarter,
} from "./rbmCalculations";
import AssigneesCompact from "./AssigneesCompact";
import ResponsiveActions from "./ResponsiveActions";
import ConfirmSubmission from "./ConfirmSubmission";
import QualityBadge from "./QualityBadge";

const MyContractItemCard = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    totalWeight,
    activity,
    index,
    no,
    loading,
    isForMonitoring,
    submissions,
    submitAssignmentReport,
    removeSubmission,
    subordinatePendingReports,
    getSubmissions,
    getSubordinatePendingReports,
    downloadSpecialOutputReportingTemplate,
    selectedFiscalYear,
  } = props;
  const open = Boolean(anchorEl);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if ((subordinatePendingReports?.allReports || 0) === 0) {
      getSubordinatePendingReports();
    }
  }, []);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [showReportingDialog, setShowReportingDialog] = useState(false);

  const weights = [
    { id: 3, name: "High" },
    { id: 2, name: "Medium" },
    { id: 1, name: "Low" },
    { id: 0, name: "Zero" },
  ];

  return (
    <>
      <Card
        className="mb-3 py-3 rounded hoverable-card"
        variant="outlined"
        style={{ backgroundColor: "#fff" }}
      >
        <CardHeader
          titleTypographyProps={{
            sx: {
              display: "-webkit-box",
              WebkitLineClamp: { xs: 2, sm: 1 },
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            },
          }}
          className="py-0"
          avatar={
            <Tooltip title="Score">
              <span
                style={{ fontSize: "12px", cursor: "default" }}
                className={`font-weight-bold  text-${
                  activity.score < 50
                    ? "danger"
                    : activity.score < 70
                    ? "warning"
                    : activity.score < 100
                    ? "info"
                    : "success"
                }`}
              >
                {activity.score.toFixed(2)} %
              </span>
            </Tooltip>
          }
          action={
            <ResponsiveActions
              activity={activity}
              setShowReportingDialog={setShowReportingDialog}
              downloading={downloading}
              downloadSpecialOutputReportingTemplate={
                downloadSpecialOutputReportingTemplate
              }
            />
          }
          title={
            <>
              <span className="text-uppercase d-inline-flex align-items-center">
                <strong className="font-weight-light">
                  {(index || no) + 1}:{activity.itemTypeName}
                </strong>
                <ArrowRightIcon className="text-primary" />
                {activity.name}
                {!!activity.isSpecial && (
                  <Chip
                    icon={
                      <span className="material-icons-round text-info">
                        stars
                      </span>
                    }
                    label="Special"
                    title="Special Output"
                    size="small"
                    variant="outlined"
                    color="info"
                  />
                )}
              </span>
            </>
          }
          subheader={
            <span>
              <span className="d-flex align-items-center justify-content-between flex-wrap">
                <span className="d-flex flex-wrap">
                  <Tooltip title="Weight">
                    <span
                      className="align-items-center"
                      style={{
                        cursor: "default",
                      }}
                    >
                      <span className="badge badge-pill text-dark px-0">
                        {weights.find(({ id }) => id === activity.weight)
                          ?.name || "n/a"}
                      </span>
                    </span>
                  </Tooltip>
                  <Tooltip title="Your target">
                    <span
                      className="align-items-center px-1 mr-2 text-info"
                      style={{
                        cursor: "default",
                      }}
                    >
                      Target: {activity.targetShare || "N/A"}
                      {activity.measurementUnit}
                      {(activity.achievedTarget > 0 ||
                        activity.targetShare > 0) && (
                        <span>
                          {" "}
                          |{" "}
                          <span
                            className={`badge badge-${
                              activity.achievedTarget ===
                                activity.targetShare && activity.targetShare > 0
                                ? "success"
                                : activity.achievedTarget > activity.targetShare
                                ? "success"
                                : "secondary"
                            }`}
                          >
                            {activity.achievedTarget} Achieved{" "}
                          </span>
                        </span>
                      )}
                    </span>
                  </Tooltip>
                  {!!activity.isRRAKey && (
                    <span
                      style={{ cursor: "default" }}
                      className="badge text-primary"
                    >
                      <i className="fas fa-key"></i> Key departmental priority
                    </span>
                  )}
                  <AssigneesCompact assignments={activity?.assignments || []} />
                </span>

                {false && (
                  <span className="d-flex flex-wrap ">
                    <span className="text-info ">
                      Deadline: {moment(activity.endOn).format("ll")}
                      <span>
                        <span
                          className={`d-flex align-items-center justify-content-center badge mx-4 badge-${
                            activity.statusId === 1
                              ? "secondary"
                              : activity.statusId === 3
                              ? "primary"
                              : activity.statusId === 4
                              ? "success"
                              : "danger"
                          }`}
                        >
                          <span
                            style={{ fontSize: "17px" }}
                            className="material-icons "
                          >
                            {activity.statusId === 1 && <>pending_actions</>}
                            {activity.statusId === 3 && <>file_present</>}
                            {activity.statusId === 4 && <>done_all</>}
                            {activity.statusId === 5 && <>close</>}
                            {activity.statusId === 2 && <>error</>}
                          </span>
                          <span style={{ fontSize: "10px" }}>
                            {activity.statusName}

                            {activity.statusId === 1 && <>...</>}
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                )}
              </span>
            </span>
          }
        />
      </Card>

      {showReportingDialog && (
        <ReportAssignment
          totalWeight={totalWeight}
          assignment={activity}
          showDialog={showReportingDialog}
          setShowDialog={setShowReportingDialog}
          index={index}
          no={no}
          loading={loading}
          submissions={submissions}
          submitAssignmentReport={submitAssignmentReport}
          removeSubmission={removeSubmission}
          getSubmissions={getSubmissions}
          subordinatePendingReports={subordinatePendingReports}
          isForMonitoring={isForMonitoring}
          selectedFiscalYear={selectedFiscalYear}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  user,
  loading,
  submissions,
  subordinatePendingReports,
  selectedFiscalYear,
}) => {
  return {
    user,
    loading,
    submissions,
    subordinatePendingReports,
    selectedFiscalYear,
  };
};
export default connect(mapStateToProps, {
  submitAssignmentReport,
  removeSubmission,
  getSubmissions,
  getSubordinatePendingReports,
  downloadSpecialOutputReportingTemplate,
})(MyContractItemCard);

const ReportAssignment = (props) => {
  const {
    assignment,
    totalWeight,
    loading,
    submitAssignmentReport,
    removeSubmission,
    getSubmissions,
    subordinatePendingReports,
    isForMonitoring,
    showDialog,
    setShowDialog,
    index,
    no,
    submissions,
    selectedFiscalYear,
  } = props;

  const [reportFormData, setReportFormData] = useState({
    achievedTarget: "",
    completed: "",
    employeeMessage: "",
    file: null,
  });

  const [selectedMonth, setSelectedMonth] = useState(null);

  const [errors, setErrors] = useState({
    hasError: false,
    achievedTargetHasError: false,
    messageHasError: false,
    fileHasError: false,
    fileErrorMessge: "",
    achievedTargetErrorMessage: "",
    messageErrorMessge: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const fyStartYear = moment(selectedFiscalYear.startOn).year();
  const quarterMonths = monthsOfQuarter(fyStartYear, assignment.quarterId);
  const monthStatuses = computeMonthlyStatuses({
    months: quarterMonths,
    submissions,
  });

  // bounds: min/max/forceEquals/isLowerBetter + UX hint
  const code = assignment.measurementUnitCode || "SUM";
  const bounds = getMeasurementBounds({
    code,
    target: assignment.targetShare,
  });

  const requireSpecialReport =
    !!assignment.isSpecial && assignment.itemTypeId === 2;

  const formValidator = () => {
    const error = {
      hasError: false,
      achievedTargetHasError: false,
      messageHasError: false,
      fileHasError: false,
      fileErrorMessge: "",
      achievedTargetErrorMessage: "",
      messageErrorMessge: "",
    };

    // month required if monthly mode
    if (assignment.reportingMode === "monthly" && !selectedMonth) {
      setErrors((e) => ({
        ...e,
        hasError: true,
        messageHasError: true,
        messageErrorMessge: "Select the month you are reporting for.",
      }));
      return true;
    }

    // completion required when target is 0 (boolean/percent path)
    if (assignment.targetShare === 0 && reportFormData.completed === "") {
      error.achievedTargetHasError = true;
      error.achievedTargetErrorMessage =
        assignment.itemTypeId === 1
          ? "Please, select the level of output completion."
          : `Please, specify if ${
              assignment.itemTypeId === 2 ? "indicator" : "activity"
            } was completed or not`;
      error.hasError = true;
    }

    // numeric required when target > 0
    if (assignment.targetShare > 0 && reportFormData.achievedTarget === "") {
      error.achievedTargetHasError = true;
      error.achievedTargetErrorMessage = `Achieved target is required`;
      error.hasError = true;
    }

    // message required
    if (!reportFormData.employeeMessage) {
      error.messageHasError = true;
      error.messageErrorMessge = `Please, fill the message field`;
      error.hasError = true;
    }

    // file validation
    if (
      requireSpecialReport &&
      reportFormData.file &&
      ![
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(reportFormData.file.type)
    ) {
      error.fileHasError = true;
      error.fileErrorMessge =
        "Only Excel files are allowed for special reports";
      error.hasError = true;
    }

    if (requireSpecialReport && !reportFormData.file) {
      error.fileHasError = true;
      error.fileErrorMessge =
        "Supporting document is required for this indicator!";
      error.hasError = true;
    }

    if (
      !requireSpecialReport &&
      reportFormData.file &&
      reportFormData.file.type !== "application/pdf"
    ) {
      error.fileHasError = true;
      error.fileErrorMessge = "Only PDF files are allowed";
      error.hasError = true;
    }

    // numeric bounds validation (when applicable)
    const numericFilled =
      assignment.targetShare > 0 && reportFormData.achievedTarget !== "";

    if (numericFilled) {
      const v = Number(reportFormData.achievedTarget);
      if (!Number.isFinite(v)) {
        error.achievedTargetHasError = true;
        error.achievedTargetErrorMessage = `Enter a valid number.`;
        error.hasError = true;
      } else {
        if (bounds.forceEquals && v !== bounds.max) {
          error.achievedTargetHasError = true;
          error.achievedTargetErrorMessage = `Value must equal ${bounds.max}.`;
          error.hasError = true;
        }
        const belowMin = bounds.min != null && v < bounds.min;
        if(belowMin){
          error.achievedTargetHasError = true;
          error.achievedTargetErrorMessage = `Value must be at least ${bounds.min}.`;
          error.hasError = true;
        }
        // const aboveMax = bounds.max != null && v > bounds.max;
        // if (belowMin || aboveMax) {
        //   error.achievedTargetHasError = true;
        //   const lo = bounds.min ?? "…";
        //   const hi = bounds.max ?? "…";
        //   error.achievedTargetErrorMessage = `Allowed range is ${lo} – ${hi}.`;
        //   error.hasError = true;
        // }
      }
    }

    setErrors(error);
    return error.hasError;
  };

  useEffect(() => {
    if (showDialog)
      getSubmissions(
        {
          assignmentId: assignment.assignmentId,
          quarterId: assignment.quarterId,
          itemTypeId: assignment.itemTypeId,
        },
        setIsLoading
      );
  }, [showDialog]);

  const onTrySubmit = () => {
    if (formValidator()) return;
    setPreviewOpen(true);
  };

  const onSubmitReport = () => {
    if (!formValidator()) {
      const reportData = new FormData();
      reportData.append("itemId", assignment.id);
      reportData.append("itemTypeId", assignment.itemTypeId);
      reportData.append("contractId", assignment.contractId);
      reportData.append("assignmentId", assignment.assignmentId);
      reportData.append("achievedTarget", reportFormData.achievedTarget);
      reportData.append("employeeMessage", reportFormData.employeeMessage);
      reportData.append("completed", reportFormData.completed);
      reportData.append("file", reportFormData.file);

      // include month for monthly reporting (all item types)
      if (assignment.reportingMode === "monthly" && selectedMonth?.m) {
        reportData.append("month", selectedMonth.m);
      }

      setPreviewOpen(false);

      submitAssignmentReport(reportData, setIsSubmitting, () =>
        setReportFormData({
          achievedTarget: "",
          completed: "",
          employeeMessage: "",
          file: null,
        })
      );
    }
  };

  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={showDialog}
        onClose={() => setShowDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="text-primary">
          <span>Assignment report</span>
          <IconButton
            aria-label="close"
            onClick={() => setShowDialog(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
          <div className="mb-1 text-black" style={{ fontSize: "11px" }}>
            <span className="text-uppercase d-inline-flex align-items-center">
              <strong className="font-weight-light">
                {(index || no) + 1}:{assignment.itemTypeName}
              </strong>
              <ArrowRightIcon className="text-primary" />
              {assignment.name}{" "}
            </span>
            <div>
              <span className="text-info">
                Target share: {assignment.targetShare}{" "}
                <Tooltip
                  title={
                    <div>
                      <div>
                        <strong>Code:</strong>{" "}
                        {assignment.measurementUnitCode || "—"}
                      </div>
                      <div>
                        <strong>Name:</strong>{" "}
                        {assignment.measurementUnitName ||
                          assignment.measurementUnit}
                      </div>
                      <div>
                        <strong>Desc:</strong>{" "}
                        {assignment.measurementUnitDesc || "—"}
                      </div>
                    </div>
                  }
                  arrow
                >
                  <IconButton
                    size="small"
                    className="ml-1"
                    aria-label="measurement unit"
                  >
                    <InfoOutlined fontSize="inherit" />{" "}
                    {assignment.measurementUnit}
                  </IconButton>
                </Tooltip>
              </span>{" "}
              | Planned from:{" "}
              <span className="text-info">
                {moment(assignment.startOn).format("ll")}
              </span>{" "}
              To:{" "}
              <span className="text-info">
                {moment(assignment.endOn).format("ll")}
              </span>
              <strong
                style={{ position: "absolute", right: 20 }}
                className="badge-info text-uppercase px-1"
              >
                quarter {assignment.quarterId}
              </strong>{" "}
            </div>
            <div>
              <span className="text-info">
                Reporting Method: {assignment.reportingMode}
              </span>
            </div>
          </div>
        </DialogTitle>

        {isSubmitting && <LinearProgress />}

        <DialogContent dividers style={{ minHeight: "52vh" }}>
          {!!subordinatePendingReports?.allReports &&
            assignment.itemTypeId !== 3 && (
              <Alert severity="warning" className="mb-2" icon={false}>
                {`Please note that you cannot submit your report if there are pending evaluations for reports submitted by your subordinates. Ensure that all ${
                  subordinatePendingReports?.forActiveReports > 0
                    ? `${subordinatePendingReports?.forActiveReports} report${
                        subordinatePendingReports?.forActiveReports > 1
                          ? "s"
                          : ""
                      } for active employee(s)`
                    : ""
                }${
                  subordinatePendingReports?.forActiveReports > 0 &&
                  subordinatePendingReports?.forExitedReports > 0
                    ? " and "
                    : ""
                }${
                  subordinatePendingReports?.forExitedReports > 0
                    ? `${subordinatePendingReports?.forExitedReports} report${
                        subordinatePendingReports?.forExitedReports > 1
                          ? "s"
                          : ""
                      } for exited employee(s)`
                    : ""
                } ${
                  subordinatePendingReports?.allReports > 1 ? "are" : "is"
                } assessed before proceeding with your submission.`}
              </Alert>
            )}

          {!!isLoading && (
            <div className="text-center mt-5">
              <img src={loadingGif} height="128" alt="loading" />
            </div>
          )}

          {!isLoading && (
            <>
              {(!!assignment.employeeTimePenalities ||
                !!assignment.employeeQualityPenalities) && (
                <div className="d-flex align-items-center justify-content-end">
                  {!!assignment.employeeTimePenalities && (
                    <span
                      className={`${
                        !!assignment.employeeQualityPenalities ? "mx-2" : ""
                      } badge badge-warning text-left text-uppercase`}
                      style={{ minWidth: "125px" }}
                    >
                      <span
                        className="badge badge-light bg-warning text-light"
                        style={{ fontSize: "12px" }}
                      >
                        {assignment.employeeTimePenalities}
                      </span>{" "}
                      Time penalty
                    </span>
                  )}
                  {!!assignment.employeeQualityPenalities && (
                    <span
                      className="badge badge-danger text-left text-uppercase"
                      style={{ minWidth: "125px" }}
                    >
                      <span
                        className="badge badge-light bg-danger text-light"
                        style={{ fontSize: "12px" }}
                      >
                        {assignment.employeeQualityPenalities}
                      </span>{" "}
                      Quality penalty
                    </span>
                  )}
                </div>
              )}

              {!!submissions.length &&
                submissions.map((submission) => (
                  <SubmissionCard
                    key={submission.id}
                    submission={submission}
                    removeSubmission={removeSubmission}
                    assignment={assignment}
                  />
                ))}

              {(!submissions.length ||
                (!!submissions &&
                  !!submissions[submissions.length - 1]?.evaluation &&
                  !submissions[submissions.length - 1]?.evaluation
                    ?.accepted)) && (
                <div className="border p-4 rounded">
                  {/* Month picker for monthly reporting */}
                  {assignment.reportingMode === "monthly" && (
                    <div className="d-flex align-items-center mb-2">
                      <small className="text-muted mr-2">Quarter months:</small>
                      <div className="d-flex flex-wrap">
                        {monthStatuses.map((m) => (
                          <Chip
                            key={m.isoMonth}
                            label={m.label}
                            onClick={() => {
                              setSelectedMonth(m);
                              setErrors((e) => ({
                                ...e,
                                messageHasError: false,
                                messageErrorMessge: "",
                              }));
                            }}
                            className="mr-1 mb-1"
                            color={
                              m.status === "reported"
                                ? "success"
                                : m.status === "missed"
                                ? "warning"
                                : "default"
                            }
                            icon={
                              m.status === "reported" ? (
                                <CheckCircleIcon />
                              ) : m.status === "missed" ? (
                                <CancelIcon />
                              ) : (
                                <HourglassEmptyIcon />
                              )
                            }
                            variant={
                              selectedMonth?.isoMonth === m.isoMonth
                                ? "filled"
                                : "outlined"
                            }
                          />
                        ))}
                      </div>
                    </div>
                  )}

                  {assignment.reportingMode === "monthly" && !selectedMonth && (
                    <Alert severity="info" className="mb-2">
                      Select a month to report.
                    </Alert>
                  )}

                  {/* Prompt text */}
                  {assignment.targetShare > 0 && assignment.itemTypeId !== 1 ? (
                    <div className="mb-2" style={{ fontSize: "13px" }}>
                      From{" "}
                      <span className="font-weight-bold text-info">
                        {assignment.targetShare} {assignment.measurementUnit}
                      </span>{" "}
                      target, how many did you achieve?
                    </div>
                  ) : assignment.itemTypeId !== 1 ? (
                    <div>
                      Is this{" "}
                      <span className="badge-info px-1">
                        {assignment.itemTypeName.toLowerCase()}
                      </span>{" "}
                      completed?
                    </div>
                  ) : (
                    <small className="mb-2">
                      At which level the annual target of this
                      <strong className="text-primary px-1">
                        {assignment.itemTypeName.toLowerCase()}
                      </strong>
                      was achieved?
                    </small>
                  )}

                  {/* Numeric input path (target > 0 & not Output itemTypeId=1) */}
                  {assignment.targetShare > 0 && assignment.itemTypeId !== 1 ? (
                    <>
                      <TextField
                        error={errors.achievedTargetHasError}
                        helperText={
                          errors.achievedTargetErrorMessage ||
                          bounds?.hint ||
                          ""
                        }
                        fullWidth
                        size="small"
                        type="number"
                        name="achievedTarget"
                        label="Achieved Target"
                        variant="outlined"
                        placeholder={String(bounds.min ?? 0)}
                        className="mb-3 mt-1"
                        disabled={
                          loading ||
                          isLoading ||
                          isSubmitting ||
                          isForMonitoring ||
                          ((subordinatePendingReports?.allReports || 0) > 0 &&
                            assignment.itemTypeId !== 3)
                        }
                        value={reportFormData.achievedTarget}
                        inputProps={{
                          min: bounds.min != null ? bounds.min : undefined,
                          max: bounds.max != null ? bounds.max : undefined,
                          step: "any",
                        }}
                        inputMode="decimal"
                        onChange={(e) => {
                          setErrors((x) => ({
                            ...x,
                            achievedTargetHasError: false,
                            achievedTargetErrorMessage: "",
                          }));
                          setReportFormData((f) => ({
                            ...f,
                            achievedTarget: e.target.value || "",
                          }));
                        }}
                      />

                      <div className="d-flex align-items-center mb-1">
                        <small className="text-muted">
                          {bounds.isLowerBetter
                            ? "Lower is better"
                            : "Higher is better"}
                        </small>
                        {bounds.min != null && (
                          <span className="badge badge-light ml-2">
                            Min: {bounds.min}
                          </span>
                        )}
                        {bounds.max != null && (
                          <span className="badge badge-light ml-1">
                            Max: {bounds.max}
                          </span>
                        )}
                      </div>

                      {/* Contextual, code-aware nudges */}
                      {Number(reportFormData.achievedTarget) === 0 &&
                        reportFormData.achievedTarget !== "" &&
                        !bounds.isLowerBetter &&
                        !errors.achievedTargetHasError && (
                          <div
                            className="alert alert-warning py-0 mt-n3"
                            style={{ borderRadius: 4 }}
                          >
                            <small style={{ fontSize: 12 }}>
                              Heads up: 0 is the lowest value for this measure
                              and will likely score poorly.
                            </small>
                          </div>
                        )}

                      {Number(reportFormData.achievedTarget) === 0 &&
                        bounds.isLowerBetter &&
                        !errors.achievedTargetHasError && (
                          <div
                            className="alert alert-success py-0 mt-n3"
                            style={{ borderRadius: 4 }}
                          >
                            <small style={{ fontSize: 12 }}>
                              0 is best for this measure (lower is better).
                            </small>
                          </div>
                        )}
                    </>
                  ) : assignment.itemTypeId !== 1 ? (
                    // Boolean/percentage path (targetShare === 0)
                    <>
                      <RadioGroup
                        row
                        aria-labelledby="demo-activity-achievement-label"
                        name="activity-achievement"
                        value={reportFormData.completed}
                        onChange={(e, v) => {
                          setErrors((x) => ({
                            ...x,
                            achievedTargetHasError: false,
                            achievedTargetErrorMessage: "",
                          }));
                          setReportFormData((f) => ({ ...f, completed: v }));
                        }}
                        disabled={
                          loading ||
                          isLoading ||
                          isSubmitting ||
                          isForMonitoring ||
                          ((subordinatePendingReports?.allReports || 0) > 0 &&
                            assignment.itemTypeId !== 3)
                        }
                      >
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>

                      {reportFormData.completed === "no" && (
                        <PercentageSelect
                          title="Progress Made (%)"
                          size="sm"
                          placeholder="Select completion percentage"
                          className="mb-3"
                          excluded={[100]}
                          value={reportFormData.achievedTarget}
                          onChange={(value) => {
                            setErrors((x) => ({
                              ...x,
                              achievedTargetHasError: false,
                              achievedTargetErrorMessage: "",
                            }));
                            setReportFormData((f) => ({
                              ...f,
                              achievedTarget: value || "",
                            }));
                          }}
                        />
                      )}

                      {reportFormData.completed === "no" &&
                        Number(reportFormData.achievedTarget || 0) === 0 && (
                          <div
                            className="alert alert-warning py-0 mb-3 mt-n2"
                            style={{ borderRadius: 4 }}
                          >
                            <small style={{ fontSize: 12 }}>
                              Zero progress will likely score 0%.
                            </small>
                          </div>
                        )}

                      {errors.achievedTargetHasError && (
                        <small className="d-block mt-n3 mb-3 text-danger">
                          <small>{errors.achievedTargetErrorMessage}</small>
                        </small>
                      )}
                    </>
                  ) : (
                    // itemTypeId === 1 (Output scale)
                    <FormControl fullWidth size="small" className="mb-3 mt-2">
                      <InputLabel
                        id="demo-simple-select-label"
                        className={`${
                          errors.achievedTargetHasError ? "text-danger" : ""
                        }`}
                      >
                        Select the level of achievement
                      </InputLabel>
                      <Select
                        error={errors.achievedTargetHasError}
                        size="small"
                        value={reportFormData.achievedTarget}
                        label="Select the level of achievement"
                        onChange={(e) => {
                          setErrors((x) => ({
                            ...x,
                            achievedTargetHasError: false,
                            achievedTargetErrorMessage: "",
                          }));
                          setReportFormData((f) => ({
                            ...f,
                            achievedTarget: e.target.value,
                          }));
                        }}
                        disabled={
                          loading ||
                          isLoading ||
                          isSubmitting ||
                          ((subordinatePendingReports?.allReports || 0) > 0 &&
                            assignment.itemTypeId !== 3)
                        }
                      >
                        <MenuItem value={100}>
                          1:Beyond expected{" "}
                          <small className="ml-1 badge-success px-1 border rounded">
                            ~100%
                          </small>
                        </MenuItem>
                        <MenuItem value={90}>
                          2:As expected{" "}
                          <small className="ml-1 badge-success px-1 border rounded">
                            ~90%
                          </small>
                        </MenuItem>
                        <MenuItem value={80}>
                          3:Great{" "}
                          <small className="ml-1 badge-info px-1 border rounded">
                            ~80%
                          </small>
                        </MenuItem>
                        <MenuItem value={70}>
                          4:Moderate{" "}
                          <small className="ml-1 badge-info px-1 border rounded">
                            ~70%
                          </small>
                        </MenuItem>
                        <MenuItem value={60}>
                          5:Fairly{" "}
                          <small className="ml-1 badge-warning px-1 border rounded">
                            ~60%
                          </small>
                        </MenuItem>
                        <MenuItem value={50}>
                          6:Few{" "}
                          <small className="ml-1 badge-warning px-1 border rounded">
                            ~50%
                          </small>
                        </MenuItem>
                        <MenuItem value={40}>
                          7:Poor{" "}
                          <small className="ml-1 badge-danger px-1 border rounded">
                            ~40%
                          </small>
                        </MenuItem>
                        <MenuItem value={20}>
                          8:Very poor{" "}
                          <small className="ml-1 badge-danger px-1 border rounded">
                            ~20%
                          </small>
                        </MenuItem>
                        <MenuItem value={0}>
                          9:Nothing done{" "}
                          <small className="ml-1 badge-danger px-1 border rounded">
                            ~00%
                          </small>
                        </MenuItem>
                      </Select>
                      <small
                        className="text-danger ml-2"
                        style={{ fontSize: "12px" }}
                      >
                        {errors.achievedTargetErrorMessage}
                      </small>
                    </FormControl>
                  )}

                  {/* Message */}
                  <TextField
                    error={errors.messageHasError}
                    helperText={errors.messageErrorMessge}
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    autoFocus={assignment.targetShare === 0}
                    name="employeeMessage"
                    label="Message"
                    variant="outlined"
                    placeholder="Message"
                    className="mb-3"
                    value={reportFormData.employeeMessage}
                    onChange={(e) => {
                      const employeeMessage = e.target.value;
                      setErrors((x) => ({
                        ...x,
                        messageHasError: false,
                        messageErrorMessge: "",
                      }));
                      setReportFormData((f) => ({ ...f, employeeMessage }));
                    }}
                    disabled={
                      loading ||
                      isLoading ||
                      isSubmitting ||
                      ((subordinatePendingReports?.allReports || 0) > 0 &&
                        assignment.itemTypeId !== 3)
                    }
                  />

                  {/* File */}
                  <div>
                    <AttachFileIcon /> Supporting document{" "}
                    <small
                      className={`badge-${
                        requireSpecialReport ? "warning" : "secondary"
                      } px-1 rounded`}
                    >
                      ({requireSpecialReport ? "Required" : "Optional"})
                    </small>{" "}
                    <small
                      style={{ fontSize: "12px" }}
                      className="font-weight-bold text-danger"
                    >
                      (Only {requireSpecialReport ? "EXCEL" : "PDF"} is allowed)
                    </small>{" "}
                  </div>
                  <div className="custom-file ">
                    <input
                      type="file"
                      className={`custom-file-input ${
                        errors.fileHasError ? "is-invalid" : ""
                      }`}
                      id="supportingDocument"
                      accept={
                        requireSpecialReport ? ".xlsx,.xls" : "application/pdf"
                      }
                      onChange={(e) => {
                        const file = e.target.files[0];

                        if (
                          requireSpecialReport &&
                          file &&
                          ![
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            "application/vnd.ms-excel",
                          ].includes(file.type)
                        ) {
                          setErrors((x) => ({
                            ...x,
                            fileHasError: true,
                            fileErrorMessge:
                              "Only Excel files are allowed for special reports",
                          }));
                          return;
                        }

                        if (
                          !requireSpecialReport &&
                          file &&
                          file.type !== "application/pdf"
                        ) {
                          setErrors((x) => ({
                            ...x,
                            fileHasError: true,
                            fileErrorMessge: "Only PDF files are allowed",
                          }));
                          return;
                        }

                        setErrors((x) => ({
                          ...x,
                          fileHasError: false,
                          fileErrorMessge: "",
                        }));

                        setReportFormData((f) => ({
                          ...f,
                          file: file || null,
                        }));
                      }}
                      disabled={
                        loading ||
                        isLoading ||
                        isSubmitting ||
                        ((subordinatePendingReports?.allReports || 0) > 0 &&
                          assignment.itemTypeId !== 3)
                      }
                    />

                    <label
                      className="custom-file-label"
                      htmlFor="supportingDocument"
                    >
                      {reportFormData.file
                        ? reportFormData.file.name
                        : "Select file..."}
                    </label>
                    {errors.fileHasError && (
                      <small className="invalid-feedback mt-0">
                        <small>{errors.fileErrorMessge}</small>
                      </small>
                    )}
                  </div>

                  {/* Submit */}
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      onClick={onTrySubmit}
                      type="button"
                      className="btn btn-primary text-uppercase px-5"
                      disabled={
                        loading ||
                        isLoading ||
                        isSubmitting ||
                        ((subordinatePendingReports?.allReports || 0) > 0 &&
                          assignment.itemTypeId !== 3)
                      }
                    >
                      {isSubmitting ? "Wait..." : "Submit"}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </DialogContent>

        <DialogActions className="d-flex justify-content-center py-4" />
      </Dialog>

      {!!previewOpen && (
        <ConfirmSubmission
          submissions={submissions}
          targetShare={assignment.targetShare}
          measurementUnitCode={assignment.measurementUnitCode || "SUM"}
          reportDeadline={assignment.endOn}
          formData={reportFormData}
          activityWeight={assignment.weight}
          totalWeight={totalWeight}
          reportingMode={assignment.reportingMode}
          selectedMonth={selectedMonth}
          measurementUnit={assignment.measurementUnit}
          onClose={() => setPreviewOpen(false)}
          onSubmit={onSubmitReport}
        />
      )}
    </>
  );
};


const SubmissionCard = ({ submission, removeSubmission, assignment }) => {
  const [confirmRemoveSubmission, setConfirmRemoveSubmission] = useState(false);
  const [viewSupportDoc, setViewSupportDoc] = useState(false);

  return (
    <>
      <div className="my-2 border rounded p-4">
        {/* report content */}
        <div className="row justify-content-start mb-3">
          <div className="col-11 text-secondary">
            <small
              className="d-flex align-items-center"
              style={{ fontSize: "12px" }}
            >
              <span className="d-none text-capitalize mr-1 d-md-inline-flex text-primary align-items-center">
                <PersonIcon />
                {submission.submitedBy?.lastName.toLowerCase()}{" "}
                {submission.submitedBy?.firstName.toLowerCase()}
              </span>{" "}
              {" /"} {moment(submission.createdOn).format("lll")}
            </small>
            <Card
              variant="outlined"
              className="rounded elevated pb-2"
              style={{ backgroundColor: "#f6f8fa" }}
            >
              <CardContent className=" pt-2 pb-2">
                <div>
                  <span className="d-flex align-items-center justify-content-between">
                    {assignment.targetShare > 0 && (
                      <span
                        className="badge badge-light mb-2 text-primary text-uppercase"
                        style={{ backgroundColor: "transparent" }}
                      >
                        {submission.achievedTarget} {assignment.measurementUnit}{" "}
                        reported
                      </span>
                    )}
                    {assignment.targetShare === 0 && (
                      <>
                        {submission.completed && (
                          <span
                            className="badge badge-light text-primary text-uppercase"
                            style={{ backgroundColor: "transparent" }}
                          >
                            Reported as completed
                          </span>
                        )}
                        {!submission.completed && (
                          <span
                            className="badge badge-light text-danger text-uppercase"
                            style={{ backgroundColor: "transparent" }}
                          >
                            Reported as Not completed
                          </span>
                        )}
                      </>
                    )}

                    {!!submission.docReferenceId && (
                      <Button
                        onClick={() => setViewSupportDoc(true)}
                        size="small"
                        className="float-right"
                      >
                        <AttachFileIcon /> Supporting Document <OpenInNewIcon />
                      </Button>
                    )}
                    {!submission.docReferenceId && (
                      <span className="float-right  badge badge-warning mt-2">
                        No file attached
                      </span>
                    )}

                    <span>
                      <span
                        className={`d-inline-flex align-items-center justify-content-center badge text-${
                          submission.statusId === 1
                            ? "secondary"
                            : submission.statusId === 4
                            ? "success"
                            : "danger"
                        }`}
                        style={{ width: "100px" }}
                      >
                        <span
                          style={{ fontSize: "17px" }}
                          className="material-icons"
                        >
                          {submission.statusId === 1 && <>pending_actions</>}
                          {submission.statusId === 4 && <>done_all</>}
                          {submission.statusId === 5 && <>close</>}
                          {submission.statusId === 2 && <>error</>}
                        </span>
                        <span
                          style={{ fontSize: "10px" }}
                          className="text-uppercase"
                        >
                          {submission.statusId !== 1 && (
                            <>{submission?.status?.name}</>
                          )}

                          {submission.statusId === 1 && <>Pending...</>}
                        </span>
                      </span>

                      <IconButton
                        disabled={!!submission.evaluation}
                        onClick={() => {
                          setConfirmRemoveSubmission(true);
                        }}
                        size="small"
                        color="error"
                        className="mr-n2 mt-n2 border bg-light "
                      >
                        <span className="material-icons ">delete_forever</span>
                      </IconButton>
                    </span>
                  </span>
                </div>

                <TextField
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                  className="mt-2 bg-white"
                  size="small"
                  multiline
                  rows={3}
                  name="name"
                  label="Employee message"
                  variant="outlined"
                  value={submission.employeeMessage}
                />
              </CardContent>
            </Card>
          </div>
          {/* {submission.statusId === 1 && (
          <div className="col-11">
            <div
              className="alert alert-light text-center py-0 mt-n0"
              style={{ borderRadius: "0px" }}
            >
              <small style={{ fontSize: "12px" }}>
                <marquee behavior="scroll" direction="left" scrollamount="4">
                  Penalties will be applied to the supervisor after{" "}
                  <strong>
                    {" "}
                    {submission.dueDays} day{submission.dueDays > 1 ? "s" : ""}
                  </strong>{" "}
                  without evaluation.{" "}
                  <span className="px-1 badge-warning">(Today included)</span>
                </marquee>
              </small>
            </div>
          </div>
        )} */}
        </div>

        {/* evaluation content */}
        {!!submission && !!submission.evaluation && (
          <div className="row justify-content-end mt-2 mb-3">
            <div className="col-11 text-right">
              <small
                className="d-flex align-items-center"
                style={{ fontSize: "12px" }}
              >
                <span className="d-none text-capitalize mr-1 d-md-inline-flex text-primary align-items-center">
                  <PersonIcon />
                  {submission.evaluation.evaluatedBy.lastName.toLowerCase()}{" "}
                  {submission.evaluation.evaluatedBy.firstName.toLowerCase()}
                </span>{" "}
                {" /"} {moment(submission.evaluation.createdOn).format("lll")}
              </small>

              <Card
                variant="outlined"
                className="rounded elevated"
                style={{ backgroundColor: "#f6f8fa" }}
              >
                <CardContent>
                  <div>
                    <div className="pb-2">
                      {submission.evaluation.accepted && (
                        <span className="float-left mt-n2 text-uppercase">
                          {assignment.targetShare > 0 && (
                            <span
                              className="badge badge-light mb-2 text-primary"
                              style={{ backgroundColor: "transparent" }}
                            >
                              {" "}
                              {submission.evaluation.achievedTarget}{" "}
                              {assignment.measurementUnit} accepted
                            </span>
                          )}
                          {assignment.targetShare === 0 && (
                            <>
                              {submission.evaluation.completed && (
                                <span
                                  className="badge badge-light text-success"
                                  style={{ backgroundColor: "transparent" }}
                                >
                                  Completed accepted
                                </span>
                              )}
                              {!submission.evaluation.completed && (
                                <span
                                  className="badge badge-light text-danger"
                                  style={{ backgroundColor: "transparent" }}
                                >
                                  Not completed
                                </span>
                              )}
                            </>
                          )}

                          {/* <span
                            className={`badge ml-2 badge-${
                              +submission.evaluation.qualityValue === 0.95
                                ? "success"
                                : +submission.evaluation.qualityValue === 0.85
                                ? "primary"
                                : +submission.evaluation.qualityValue === 0.75
                                ? "info"
                                : +submission.evaluation.qualityValue === 0.6
                                ? "warning"
                                : "danger"
                            }`}
                          >
                            {+submission.evaluation.qualityValue === 0.95
                              ? "Excellent"
                              : +submission.evaluation.qualityValue === 0.85
                              ? "Very Good"
                              : +submission.evaluation.qualityValue === 0.75
                              ? "Good"
                              : +submission.evaluation.qualityValue === 0.6
                              ? "Fair"
                              : "Poor"}{" "}
                          </span> */}
                          <QualityBadge
                            value={+submission.evaluation.qualityValue}
                          />
                        </span>
                      )}

                      {!submission.evaluation.accepted && (
                        <div className="pb-2">
                          <span className="float-left text-uppercase">
                            <span
                              className="badge badge-light mb-2 text-danger"
                              style={{ backgroundColor: "transparent" }}
                            >
                              {/* <i className="fas fa-times text-danger"></i>{" "} */}
                              Rejected
                            </span>
                          </span>
                        </div>
                      )}

                      <span className="float-right mt-n2 text-uppercase d-inline-flex mt-1 align-items-center">
                        {submission.evaluation.accepted && (
                          <>
                            <span
                              className="badge badge-light mr-2 text-primary"
                              style={{ backgroundColor: "transparent" }}
                            >
                              Score:{" "}
                            </span>
                            <span style={{ width: "150px" }} className="mr-1">
                              <CustomProgressLine
                                value={submission.evaluation.score}
                                height={16}
                              />
                            </span>
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                  <TextField
                    style={{ backgroundColor: "#f6f8fa" }}
                    fullWidth
                    size="small"
                    InputProps={{
                      readOnly: true,
                    }}
                    multiline
                    className="mt-2"
                    rows={3}
                    name="name"
                    autoFocus
                    label="Supervisor comment"
                    variant="outlined"
                    value={submission.evaluation.supervisorComment}
                  />
                </CardContent>
              </Card>
            </div>
          </div>
        )}
      </div>

      <ConfirmationDialog
        confirmationDialog={confirmRemoveSubmission}
        message={`Are you sure you want to remove this submission?`}
        setConfirmationDialog={setConfirmRemoveSubmission}
        onYes={() =>
          removeSubmission(
            {
              submissionId: submission.id,
              assignmentId: assignment.assignmentId,
              contractId: assignment.contractId,
              itemId: assignment.id,
              itemTypeId: assignment.itemTypeId,
            },
            setConfirmRemoveSubmission
          )
        }
      />

      {!!viewSupportDoc && (
        <PreviewPdfUrl
          showDocument={viewSupportDoc}
          setShowDocument={setViewSupportDoc}
          document={{
            name: `View Supporting Document`,
            url:
              process.env.REACT_APP_FILES_URL +
              "/preview/" +
              submission.docReferenceId,
          }}
        />
      )}
    </>
  );
};
